import { deserialize } from './serialize';
import { type } from './shared';

const JsxText = {
  deserialize,
  type,
};

export default JsxText;
